import {tagStat, setTagCookie} from "../api/stat";

export function tag(stat) {
  tagStat({stat}).then(res => {
    setTagCookie({stat})
  })
}

